<!-- Adapted from YesPlayMusic v0.4.11 views/next.vue, MIT, qier222. Queue data uses the shared playback runtime. -->
<template>
  <div class="next-tracks" :class="{'salt-next-page':salt}">
    <h1>正在播放</h1>
    <TrackList v-if="currentTrack" :tracks="[currentTrack]" type="playlist" preserve-playback-context />
    <p v-else class="empty-state">选择一首歌曲开始播放。</p>
    <h1 v-show="playNextTracks.length">插队播放<component :is="salt ? 'SaltButton' : 'button'" style-type="subtle" @click="runtime.clearPlayNext()">清除插队</component></h1>
    <TrackList v-show="playNextTracks.length" :tracks="playNextTracks" type="playlist" :highlight-playing-track="false" item-key="id+index" preserve-playback-context />
    <h1>接下来播放<component :is="salt ? 'SaltButton' : 'button'" v-if="state.queue.length || playNextTracks.length" style-type="subtle" @click="runtime.clearQueue()">清除队列</component></h1>
    <TrackList :tracks="filteredTracks" type="playlist" :highlight-playing-track="false" preserve-playback-context />
    <p v-if="!filteredTracks.length" class="empty-state">当前播放列表没有后续歌曲。</p>
  </div>
</template>
<script>
import {runtime} from '../bridge';
import TrackList from '../components/TrackList.vue';
import {workspace} from '../workspace';
import SaltButton from '../salt/ui/SaltButton.vue';
export default {
  name:'Next',components:{TrackList,SaltButton},data(){return {runtime,workspace,state:runtime.state,ui:runtime.ui}},
  computed:{
    salt(){return this.workspace.appearance==='salt'},
    currentTrack(){return this.state.tracks.find(t=>t.id===this.state.currentId)},
    playNextTracks(){return this.ui.playNextIds.map(id=>this.state.tracks.find(t=>t.id===id)).filter(Boolean)},
    filteredTracks(){const current=this.state.currentId;void this.state.queue.length;void this.state.playMode;const snapshot=runtime.playbackSnapshot();const list=snapshot.list;return list.slice(Math.max(0,list.indexOf(current)+1)).map(id=>this.state.tracks.find(t=>t.id===id)).filter(Boolean)},
  },
};
</script>
<style lang="scss" scoped>
.salt-next-page h1 { font-size:20px;font-weight:400;margin:24px 0 12px;color:var(--salt-text); }
.salt-next-page h1:first-child { margin-top:0; }
h1 {
  margin-top: 36px;
  margin-bottom: 18px;
  cursor: default;
  color: var(--color-text);
  display: flex;
  justify-content: space-between;
  button:not(.salt-ui-button) {
    color: var(--color-text);
    border-radius: 8px;
    padding: 0 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
    opacity: 0.68;
    font-weight: 500;
    &:hover {
      opacity: 1;
      background: var(--color-secondary-bg);
    }
    &:active {
      opacity: 1;
      transform: scale(0.92);
    }
  }
}
</style>
